import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

import LogoUrl from '../../../../resources/logo.svg';
import DownloadIconUrl from '../../../../resources/icons/icon-download-black.svg';

import { 
  DOWNLOAD_TEXT,
  MENU_DESKTOP_WIDTH,
  PRESENTATION_TEXT,
  LINKS,
  WEBSITE_URL,
  PDF_NAME_HR,
} from '../../../../config';

import ShareButton from './ShareButton';

import styles from '../styles';

class DesktopAppMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentHighlightedItem: null,
      isHover: false,
    }
  }
  /**
   * HANDLE
   */
  handleMouseEnter(evt, params = null) {
    const setState = {
      isHover: true,
    };
    if (params) {
      setState.currentHighlightedItem = params;
    }
    this.setState(setState);
  }
  
  handleMouseLeave(evt) {
    const { relatedTarget, toElement } = evt.nativeEvent;
    if (relatedTarget) {
      if (relatedTarget.classList.contains('bookmarkButton')) {
        return;
      }
      if (relatedTarget.closest('.subDrawer')) {
        return;
      }
    }
    if (toElement) {
      if (toElement.classList.contains('bookmarkButton')) {
        return;
      }
      if (toElement.closest('.subDrawer')) {
        return;
      }
    }
    this.setState({ isHover: false });
  }

  /**
   * RENDER
   */
  renderMainDrawer() {
    const { classes, fullscreen, fileURL, page } = this.props;
    return (
      <Drawer
        className={classes.mainDrawer}
        variant="persistent"
        anchor="left"
        open={!fullscreen}
      >
        <Box className={classes.mainDrawerHeader} sx={{flexGrow: 1}}>
          <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer">
            <img src={LogoUrl} alt="LUCIOLE" />
          </a>
          <Typography className={classes.mainDrawerParagraph}>
            {PRESENTATION_TEXT}
          </Typography>
          <Typography className={classes.buttonDrawerParagraph}>
            {LINKS[page] &&
              <a href={LINKS[page].url} target="_blank" className={classes.mainDrawerHeaderLink} rel="noreferrer">
                {LINKS[page].title}
              </a>
            }
          </Typography>
        </Box>

        <Stack className={classes.socialList} justifyContent='center' style={{ paddingBottom: '32px' }}>
          <Stack>
            <ShareButton classes={classes} />
            <ListItem key="download" className={classes.listItem} disablePadding>
              <ListItemButton
                onClick={() => {
                  // Event for Downloads stat with analytics
                  // window.gtag('event', 'download_pdf', {
                  //   'event_category': 'Luciole',
                  //   'event_label': 'download_pdf_click'
                  // });
                  const link = document.createElement("a");
                  // link.href = fileURL;
                  link.href = `${window.location.pathname}${PDF_NAME_HR}`;
                  link.download = 'LUCIOLE-Cartes_de_voeux.pdf';
                  link.click();
                  if (window.umami) {
                    window.umami.track('Portfolio Cartes de voeux - Download');
                  }
                }}
              >
                <ListItemIcon>
                  <img className={classes.menuIcon} src={DownloadIconUrl} alt={DOWNLOAD_TEXT} />
                </ListItemIcon>
                <ListItemText className={`${classes.drawerLabel}`} primary={<Typography variant="h4">{DOWNLOAD_TEXT}</Typography>} />
              </ListItemButton>
            </ListItem>
          </Stack>
        </Stack>
      </Drawer>
    );
  }

  render() {
    const { classes, fullscreen } = this.props;
    return (
      <Stack
        className={classes.desktopMenuContainer}
        sx={{ width: fullscreen ? 0 : MENU_DESKTOP_WIDTH }}
        direction="row"
      >
        {this.renderMainDrawer()}
      </Stack>
    );
  }
}

DesktopAppMenu.defaultProps = {
  page: 0,
};

DesktopAppMenu.propTypes = {
  // props
  fullscreen: PropTypes.bool,
  page: PropTypes.number,
  fileURL: PropTypes.string,
  // funcs
  onNavigate: PropTypes.func.isRequired,
};

export default withStyles(styles)(DesktopAppMenu);
